(function(){

/* ===================== TRANSLATIONS ===================== */
var translations = {
  it:{
    recipient:'Destinatario',story:'Storia',details:'Dettagli',
    song_price:'🔥 Prezzo Black Friday',
    price_label:'Prezzo',
    delivery_label:'Consegna',
    total_label:'Totale',
    included:'Incluso',
    express_delivery:'Express (1 ora)',
    fast_delivery:'Veloce (3-5 ore)',
    standard_delivery:'Standard (10-12 ore)',
    choose_type:'Scegli che tipo di canzone personalizzata vuoi creare',
    love:'Amore',birthday:'Compleanno',family:'Famiglia',joke:'Scherzo',children:'Bambini',freestyle:'Idea Libera',
    choose_language:'Scegli la lingua della canzone',select_language:'Seleziona lingua',
    name_label:'Nome della persona',name_placeholder:"es. Anna, Luca, Mamma, Max (il nostro cane)",
    select_genre:'Seleziona genere',choose_mood:'Scegli un mood',select_mood:'Seleziona mood',
    choose_style:'Scegli uno stile di canzone',select_style:'Seleziona stile',
    person_age:'Quanti anni compie la persona',
    story_label:'Qual è la storia o il messaggio che vuoi nella canzone?',
    // per-product example placeholders (IT)
    love_placeholder:"es. Come ci siamo conosciuti a Parigi",
    birthday_placeholder:"es. Maria",
    family_placeholder:"es. Mamma – Ana, Papà – Javier, Figli – Sofia e Matteo...",
    joke_placeholder:"es. Il mio amico Jorge, i miei colleghi, il mio capo, il Real Madrid",
    children_placeholder:"es. Emma, 2 anni",
    freestyle_placeholder:"es. Il mio cane che ruba la pizza",
    story_placeholder:'es. Come ci siamo incontrati a Parigi...',
    'Surprise me':'Sorprendimi','Birthday style':'Stile compleanno','Pop-rock':'Pop-rock','Pop':'Pop','Rock':'Rock','Jazz':'Jazz','Blues':'Blues','Hip-hop':'Hip-hop','Folk':'Folk','Rap':'Rap','Soul':'Soul','Country':'Country','Electronic':'Electronic','Reggae':'Reggae',
    Romantic:'Romantico',Emotional:'Emozionale',Funny:'Divertente',Nostalgic:'Nostalgico',Flirty:'Civettuolo',Epic:'Epico',Cute:'Carino',
    Playful:'Giocoso',Lullaby:'Ninna nanna',
    more_details:"Dimmi di più (Facoltativo)",more_placeholder:'Puoi scrivere tutto ciò che vorresti includere...',
    preferred_vocal:'Voce preferita',male:'Maschio',female:'Femmina','no_preference':'Nessuna preferenza',
    delivery_speed:'Velocità di consegna',select_delivery:'Seleziona tempo di consegna',
    back:'Indietro',next:'Avanti',checkout:'Procedi al Checkout',
    love_name:"Per chi è questa canzone d'amore?",birthday_name:'Qual è il nome o soprannome di questa persona:',family_name:'Quali membri della famiglia dovrebbero essere menzionati?',joke_name:'Di chi o di cosa dovrebbe parlare la canzone?',children_name:'Nome e età del bambino',freestyle_name:'Di cosa dovrebbe parlare la canzone?',
    birthday_story:'Cosa ama o apprezza questa persona? Abitudini divertenti, storie o battute interne?',family_story:'Ricordi speciali o tradizioni familiari?',joke_story:"Cosa gli piace fare o cosa fa di divertente?",children_story:'Cosa li fa sorridere',freestyle_story:'Qual è la storia o il messaggio che vuoi nella canzone?',
    children_more:'Dimmi di più sul bambino',other_more:'Dimmi di più (Facoltativo)',
    err_dedication:'Per favore scegli un\'opzione.',
    err_name:'Per favore inserisci un nome.',
    err_language:'Per favore seleziona una lingua.',
    err_genre:'Per favore seleziona un genere.',
    err_mood:'Per favore seleziona un mood.',
    err_style:'Per favore seleziona uno stile.',
    err_age:'Per favore inserisci un\'età.',
    err_story:'Per favore condividi qualche riga.',
    err_vocal:'Per favore scegli una preferenza vocale.',
    err_delivery:'Per favore seleziona una velocità di consegna.'

  },

  el:{
    recipient:'Παραλήπτης',story:'Ιστορία',details:'Λεπτομέρειες',
    song_price:'🔥 Τιμή Black Friday',
    price_label:'Τιμή',
    delivery_label:'Παράδοση',
    total_label:'Σύνολο',
    included:'Περιλαμβάνεται',
    express_delivery:'Express (1 ώρα)',
    fast_delivery:'Γρήγορη (3–5 ώρες)',
    standard_delivery:'Κανονική (10–12 ώρες)',
    choose_type:'Επιλέξτε τι τύπο εξατομικευμένου τραγουδιού θέλετε να δημιουργήσετε',
    love:'Αγάπη',birthday:'Γενέθλια',family:'Οικογένεια',joke:'Αστείο',children:'Παιδιά',freestyle:'Ανοιχτή Ιδέα',
    choose_language:'Επιλέξτε τη γλώσσα του τραγουδιού',select_language:'Επιλέξτε γλώσσα',
    name_label:'Όνομα του ατόμου',name_placeholder:'π.χ. Άννα, Λουκάς, Μαμά, Μαξ (ο σκύλος μας)',
    select_genre:'Επιλέξτε είδος',choose_mood:'Επιλέξτε διάθεση',select_mood:'Επιλέξτε διάθεση',
    choose_style:'Επιλέξτε στυλ τραγουδιού',select_style:'Επιλέξτε στυλ',
    person_age:'Πόσο χρονών γίνεται το άτομο',
    story_label:'Ποια είναι η ιστορία ή το μήνυμα που θέλετε στο τραγούδι;',
    // per-product example placeholders (EL)
    love_placeholder:"π.χ. Πώς γνωριστήκαμε στο Παρίσι",
    birthday_placeholder:"π.χ. Μαρία",
    family_placeholder:"π.χ. Μαμά – Άννα, Μπαμπάς – Χαβιέ, Παιδιά – Σοφία και Ματέο...",
    joke_placeholder:"π.χ. Ο φίλος μου ο Χόρχε, οι συνάδελφοί μου, το αφεντικό μου, η Ρεάλ Μαδρίτης",
    children_placeholder:"π.χ. Έμμα, 2 ετών",
    freestyle_placeholder:"π.χ. Ο σκύλος μου που κλέβει πίτσα",
    story_placeholder:'π.χ. Πώς συναντηθήκαμε στο Παρίσι...',
    'Surprise me':'Εκπλήξτε με','Birthday style':'Στυλ γενεθλίων','Pop-rock':'Ποπ-ροκ','Pop':'Ποπ','Rock':'Ροκ','Jazz':'Τζαζ','Blues':'Μπλουζ','Hip-hop':'Χιπ-χοπ','Folk':'Φολκ','Rap':'Ραπ','Soul':'Σόουλ','Country':'Κάντρι','Electronic':'Ηλεκτρονική','Reggae':'Ρέγκε',
    Romantic:'Ρομαντικό',Emotional:'Συναισθηματικό',Funny:'Αστείο',Nostalgic:'Νοσταλγικό',Flirty:'Φλερτ',Epic:'Επικό',Cute:'Χαριτωμένο',
    Playful:'Παιχνιδιάρικο',Lullaby:'Νανούρισμα',
    more_details:'Πείτε μου περισσότερα (Προαιρετικό)',more_placeholder:'Μπορείτε να γράψετε ό,τι θέλετε να συμπεριληφθεί...',
    preferred_vocal:'Προτιμώμενη φωνή',male:'Άνδρας',female:'Γυναίκα','no_preference':'Χωρίς προτίμηση',
    delivery_speed:'Ταχύτητα παράδοσης',select_delivery:'Επιλέξτε χρόνο παράδοσης',
    back:'Πίσω',next:'Επόμενο',checkout:'Συνέχεια στο Checkout',
    love_name:'Για ποιον είναι αυτό το τραγούδι αγάπης;',birthday_name:'Ποιο είναι το όνομα ή το παρατσούκλι αυτού του ατόμου:',family_name:'Ποια μέλη της οικογένειας πρέπει να αναφερθούν;',joke_name:'Ποιος ή τι πρέπει να είναι το τραγούδι;',children_name:'Όνομα και ηλικία του παιδιού',freestyle_name:'Για τι πρέπει να είναι το τραγούδι;',
    birthday_story:'Τι αγαπά ή απολαμβάνει αυτό το άτομο; Αστείες συνήθειες, ιστορίες ή εσωτερικά αστεία;',family_story:'Ειδικές αναμνήσεις ή οικογενειακές παραδόσεις;',joke_story:'Τι απολαμβάνουν ή κάνουν που είναι αστείο;',children_story:'Τι τους κάνει να χαμογελούν',freestyle_story:'Ποια είναι η ιστορία ή το μήνυμα που θέλετε στο τραγούδι;',
    children_more:'Πείτε μου περισσότερα για το παιδί',other_more:'Πείτε μου περισσότερα (Προαιρετικό)',
    err_dedication:'Παρακαλώ επιλέξτε μία επιλογή.',
    err_name:'Παρακαλώ εισάγετε ένα όνομα.',
    err_language:'Παρακαλώ επιλέξτε μία γλώσσα.',
    err_genre:'Παρακαλώ επιλέξτε ένα είδος.',
    err_mood:'Παρακαλώ επιλέξτε μία διάθεση.',
    err_style:'Παρακαλώ επιλέξτε ένα στυλ.',
    err_age:'Παρακαλώ εισάγετε μία ηλικία.',
    err_story:'Παρακαλώ μοιραστείτε μερικές γραμμές.',
    err_vocal:'Παρακαλώ επιλέξτε μία προτίμηση φωνής.',
    err_delivery:'Παρακαλώ επιλέξτε ταχύτητα παράδοσης.'
  },

  pt:{
    recipient:'Destinatário',story:'História',details:'Detalhes',
    song_price:'🔥 Preço Black Friday',
    price_label:'Preço',
    delivery_label:'Entrega',
    total_label:'Total',
    included:'Incluído',
    express_delivery:'Express (1 hora)',
    fast_delivery:'Rápida (3–5 horas)',
    standard_delivery:'Padrão (10–12 horas)',
    choose_type:'Escolha que tipo de música personalizada você quer criar',
    love:'Amor',birthday:'Aniversário',family:'Família',joke:'Piada',children:'Crianças',freestyle:'Ideia Livre',
    choose_language:'Escolha o idioma da música',select_language:'Selecione o idioma',
    name_label:'Nome da pessoa',name_placeholder:'ex. Anna, Luca, Mãe, Max (nosso cachorro)',
    select_genre:'Selecione o gênero',choose_mood:'Escolha um mood',select_mood:'Selecione o mood',
    choose_style:'Escolha um estilo de música',select_style:'Selecione o estilo',
    person_age:'Quantos anos a pessoa está fazendo',
    story_label:'Qual é a história ou mensagem que você quer na música?',
    // per-product example placeholders (PT-PT)
    love_placeholder:"ex. Como nos conhecemos em Paris",
    birthday_placeholder:"ex. Maria",
    family_placeholder:"ex. Mãe – Ana, Pai – Javier, Filhos – Sofia e Mateo...",
    joke_placeholder:"ex. O meu amigo Jorge, os meus colegas, o meu chefe, o Real Madrid",
    children_placeholder:"ex. Emma, 2 anos",
    freestyle_placeholder:"ex. O meu cão a roubar pizza",
    story_placeholder:'ex. Como nos conhecemos em Paris...',
    'Surprise me':'Surpreenda-me','Birthday style':'Estilo de aniversário','Pop-rock':'Pop-rock','Pop':'Pop','Rock':'Rock','Jazz':'Jazz','Blues':'Blues','Hip-hop':'Hip-hop','Folk':'Folk','Rap':'Rap','Soul':'Soul','Country':'Country','Electronic':'Eletrônica','Reggae':'Reggae',
    Romantic:'Romântico',Emotional:'Emocional',Funny:'Engraçado',Nostalgic:'Nostálgico',Flirty:'Flerte',Epic:'Épico',Cute:'Fofo',
    Playful:'Brincalhão',Lullaby:'Canção de ninar',
    more_details:'Conte-me mais (Opcional)',more_placeholder:'Você pode escrever qualquer coisa que gostaria de incluir...',
    preferred_vocal:'Voz preferida',male:'Masculino',female:'Feminino','no_preference':'Sem preferência',
    delivery_speed:'Velocidade de entrega',select_delivery:'Selecione o tempo de entrega',
    back:'Voltar',next:'Próximo',checkout:'Prosseguir para o Checkout',
    love_name:'Para quem é esta música de amor?',birthday_name:'Qual é o nome ou apelido desta pessoa:',family_name:'Quais membros da família devem ser mencionados?',joke_name:'Quem ou o que deve ser a música?',children_name:'Nome e idade da criança',freestyle_name:'Sobre o que deve ser a música?',
    birthday_story:'O que essa pessoa ama ou gosta? Hábitos engraçados, histórias ou piadas internas?',family_story:'Memórias especiais ou tradições familiares?',joke_story:'O que eles gostam ou fazem que é engraçado?',children_story:'O que os faz sorrir',freestyle_story:'Qual é a história ou mensagem que você quer na música?',
    children_more:'Conte-me mais sobre a criança',other_more:'Conte-me mais (Opcional)',
    err_dedication:'Por favor, escolha uma opção.',
    err_name:'Por favor, insira um nome.',
    err_language:'Por favor, selecione um idioma.',
    err_genre:'Por favor, selecione um gênero.',
    err_mood:'Por favor, selecione um mood.',
    err_style:'Por favor, selecione um estilo.',
    err_age:'Por favor, insira uma idade.',
    err_story:'Por favor, compartilhe algumas linhas.',
    err_vocal:'Por favor, escolha uma preferência vocal.',
    err_delivery:'Por favor, selecione uma velocidade de entrega.'
  }
};

/* Detect current language from URL (handles /pt-pt/, /pt-br/, /pt/) */
function getCurrentLanguage(){
  var path=window.location.pathname||'';
  path=path.toLowerCase();
  if(path.includes('/it/')||path.startsWith('/it')) return 'it';
  if(path.includes('/el/')||path.startsWith('/el')) return 'el';
  if(path.includes('/pt-pt/')||path.includes('/pt-br/')||path.includes('/pt/')||path.startsWith('/pt')) return 'pt';
  return 'en';
}
function t(key,lang){
  if(!lang||lang==='en'||!translations[lang]) return null;
  return translations[lang][key]||null;
}
var currentLang=getCurrentLanguage();

/* Apply translations to static parts + select placeholders */
function applyTranslations(){
  if(currentLang==='en') return;
  var trans=translations[currentLang]; if(!trans) return;

  // Stepper
  var stepperLabels=document.querySelectorAll('.ss-stepper .ss-label');
  if(stepperLabels[0]&&trans.recipient) stepperLabels[0].textContent=trans.recipient;
  if(stepperLabels[1]&&trans.story)     stepperLabels[1].textContent=trans.story;
  if(stepperLabels[2]&&trans.details)   stepperLabels[2].textContent=trans.details;

  // Step 1 title label
  var chooseTypeLabel=document.getElementById('chooseTypeLabel');
  if(chooseTypeLabel&&trans.choose_type) chooseTypeLabel.textContent=trans.choose_type;

  // Product chips text (keep emoji)
  document.querySelectorAll('#dedicationGrid .ss-chip').forEach(function(chip){
    var value=chip.getAttribute('data-value'); var node=chip.firstChild;
    var label=null;
    if(value==='Love Song') label=trans.love;
    if(value==='Happy Birthday') label=trans.birthday;
    if(value==='Family Song') label=trans.family;
    if(value==='Joke Song') label=trans.joke;
    if(value==='Children Song') label=trans.children;
    if(value==='Freestyle Song') label=trans.freestyle;
    if(label && node && node.nodeType===3){
      var parts=node.textContent.trim().split(' ');
      var emoji=parts[0]||'';
      node.textContent=(emoji?emoji+' ':'')+label+' ';
    }
  });

  // Language field
  var langLabel=document.getElementById('langFieldLabel');
  if(langLabel&&trans.choose_language) langLabel.textContent=trans.choose_language;
  var langSelect=document.getElementById('song_language');
  if(langSelect&&trans.select_language) langSelect.options[0].textContent=trans.select_language;

  // Default name label/placeholder (overwritten by chips later)
  var nameLabel=document.getElementById('nameLabel');
  if(nameLabel&&trans.name_label) nameLabel.textContent=trans.name_label;
  var nameInput=document.getElementById('recipient_name');
  if(nameInput&&trans.name_placeholder) nameInput.placeholder=trans.name_placeholder;

  // Step 2 field labels + placeholders
  var genreLabel=document.getElementById('genreLabel'); if(genreLabel&&trans.select_genre) genreLabel.textContent=trans.select_genre;
  var moodLabel=document.getElementById('moodLabel');   if(moodLabel&&trans.choose_mood)   moodLabel.textContent=trans.choose_mood;
  var moodSelect=document.getElementById('song_mood');  if(moodSelect&&trans.select_mood)  moodSelect.options[0].textContent=trans.select_mood;
  var styleLabel=document.getElementById('styleLabel'); if(styleLabel&&trans.choose_style) styleLabel.textContent=trans.choose_style;
  var styleSelect=document.getElementById('song_style'); if(styleSelect&&trans.select_style) styleSelect.options[0].textContent=trans.select_style;
  var ageLabel=document.getElementById('ageLabel');     if(ageLabel&&trans.person_age)     ageLabel.textContent=trans.person_age;

  // Story + placeholder
  var sLabel=document.getElementById('storyLabel'); if(sLabel&&trans.story_label) sLabel.textContent=trans.story_label;
  var sArea=document.getElementById('song_story');  if(sArea&&trans.story_placeholder) sArea.placeholder=trans.story_placeholder;

  // Step 3 labels + placeholders
  var mLabel=document.getElementById('moreDetailsLabel'); if(mLabel&&trans.other_more) mLabel.textContent=trans.other_more;
  var mArea=document.getElementById('more_details'); if(mArea&&trans.more_placeholder) mArea.placeholder=trans.more_placeholder;
  var vLabel=document.getElementById('vocalLabel'); if(vLabel&&trans.preferred_vocal) vLabel.textContent=trans.preferred_vocal;

  // Vocal buttons
  document.querySelectorAll('.ss-vocal span').forEach(function(span){
    var txt=span.textContent.trim();
    if(/Male/i.test(txt)   && trans.male)          span.textContent=trans.male;
    if(/Female/i.test(txt) && trans.female)        span.textContent=trans.female;
    if(/No preference/i.test(txt) && trans.no_preference) span.textContent=trans.no_preference;
  });

  // Delivery labels/placeholders
  var dLabel=document.getElementById('deliveryLabel'); if(dLabel&&trans.delivery_speed) dLabel.textContent=trans.delivery_speed;
  var dSelect=document.getElementById('delivery_speed'); if(dSelect&&trans.select_delivery) dSelect.options[0].textContent=trans.select_delivery;

  // Buttons
  document.querySelectorAll('.ss-back').forEach(function(b){ if(trans.back) b.textContent=trans.back; });
  document.querySelectorAll('.ss-next').forEach(function(b){ if(trans.next) b.textContent=trans.next; });
  var cBtn=document.getElementById('checkoutBtn'); if(cBtn&&trans.checkout) cBtn.textContent=trans.checkout;

  // Translate selects already populated
  translateSelectOptions('song_genre');
  translateSelectOptions('song_style');
  translateMoodOptions();

  // "Song price"
  var songPriceLabels=document.querySelectorAll('.ss-song-price-label');
  if(songPriceLabels.length && trans.song_price){
    songPriceLabels.forEach(function(label){
      label.textContent=trans.song_price;
    });
  }

  // Price breakdown labels
  var priceLabel=document.querySelector('.ss-trans-price');
  if(priceLabel && trans.price_label) priceLabel.textContent=trans.price_label;
  var deliveryLabel=document.querySelector('.ss-trans-delivery');
  if(deliveryLabel && trans.delivery_label) deliveryLabel.textContent=trans.delivery_label;
  var totalLabel=document.querySelector('.ss-trans-total');
  if(totalLabel && trans.total_label) totalLabel.textContent=trans.total_label;
  var includedLabel=document.querySelector('.ss-trans-included');
  if(includedLabel && trans.included && includedLabel.textContent==='Included') {
    includedLabel.textContent=trans.included;
  }

  // Delivery speed options
  var deliverySelect=document.getElementById('delivery_speed');
  if(deliverySelect && trans){
    var options=deliverySelect.options;
    for(var i=1; i<options.length; i++){
      var opt=options[i];
      var variantId=opt.value;
      if(variantId==='46830917615846' && trans.express_delivery){
        opt.textContent=trans.express_delivery+' | €9.99';
      } else if(variantId==='46830917583078' && trans.fast_delivery){
        opt.textContent=trans.fast_delivery+' | €3.99';
      } else if(variantId==='46830917550310' && trans.standard_delivery){
        opt.textContent=trans.standard_delivery+' | €0.00';
      }
    }
  }
  if(trans.err_dedication) document.getElementById('errDedication').textContent=trans.err_dedication;
  if(trans.err_name) document.getElementById('errName').textContent=trans.err_name;
  if(trans.err_language) document.getElementById('errLanguage').textContent=trans.err_language;
  if(trans.err_genre) document.getElementById('errGenre').textContent=trans.err_genre;
  if(trans.err_mood) document.getElementById('errMood').textContent=trans.err_mood;
  if(trans.err_style) document.getElementById('errStyle').textContent=trans.err_style;
  if(trans.err_age) document.getElementById('errAge').textContent=trans.err_age;
  if(trans.err_story) document.getElementById('errStory').textContent=trans.err_story;
  if(trans.err_vocal) document.getElementById('errVocal').textContent=trans.err_vocal;
  if(trans.err_delivery) document.getElementById('errDelivery').textContent=trans.err_delivery;

}

/* Translate options helper */
function translateSelectOptions(selectId){
  if(currentLang==='en') return;
  var trans=translations[currentLang]; if(!trans) return;
  var sel=document.getElementById(selectId); if(!sel) return;
  for(var i=1;i<sel.options.length;i++){
    var opt=sel.options[i];
    var val=opt.textContent.trim();
    if(trans[val]) opt.textContent=trans[val];
  }
}
function translateMoodOptions(){
  if(currentLang==='en') return;
  var trans=translations[currentLang]; if(!trans) return;
  var sel=document.getElementById('song_mood'); if(!sel) return;
  for(var i=1;i<sel.options.length;i++){
    var opt=sel.options[i];
    var val=opt.textContent.trim();
    if(trans[val]) opt.textContent=trans[val];
  }
}

/* ===================== ORIGINAL LOGIC ===================== */
var form=document.getElementById('slaysong-wizard');
var steps=Array.from(document.querySelectorAll('.ss-step'));
var stepBtns=Array.from(document.querySelectorAll('.ss-stepper-item'));
var line=document.querySelector('.ss-stepper-line');

var productConfigs={
  'Love Song':{
    step1:{nameLabel:'Who is this love song for?',namePlaceholder:'e.g. My wife Marta, My boyfriend Luca...'},
    step2:{genres:['Surprise me','Pop-rock','Pop','Rock','Jazz','Blues','Hip-hop','Folk'],moods:['Romantic','Emotional','Funny','Nostalgic','Flirty'],showMood:true,showAge:false,showStyle:false,storyLabel:"What's the story or message you want in the song?",storyPlaceholder:'e.g. How we met in Paris...'},
    step3:{moreDetailsLabel:'Tell me more (optional)',moreDetailsPlaceholder:'You can write anything you\'d like to be included...'}
  },
  
  'Happy Birthday':{
    step1:{nameLabel:"What's this person's Name or Nickname:",namePlaceholder:'e.g. Maria'},
    step2:{genres:['Birthday style','Pop-rock','Pop','Rock','Jazz','Blues','Hip-hop','Folk'],moods:[],showMood:false,showAge:true,showStyle:false,storyLabel:'What does this person love or enjoy? Funny habits, stories, or inside jokes?',storyPlaceholder:'e.g. Loves wine, dancing, traveling. Sings in the shower...'},
    step3:{moreDetailsLabel:'Tell me more (optional)',moreDetailsPlaceholder:'You can write anything you\'d like to be included...'}
  },

  'Family Song':{
    step1:{nameLabel:'Which family members should be mentioned?',namePlaceholder:'e.g. Mom - Ana, Dad - Javier, Kids - Sofia and Mateo...'},
    step2:{genres:['Surprise me','Pop','Rock','Pop-Rock','Hip-hop','Jazz','Electronic','Reggae','Folk'],moods:[],showMood:false,showAge:false,showStyle:false,storyLabel:'Any special memories or family traditions?',storyPlaceholder:'e.g. Family reunions, vacations, funny stories...'},
    step3:{moreDetailsLabel:'Tell me more (optional)',moreDetailsPlaceholder:'You can write anything you\'d like to be included...'}
  },
  'Joke Song':{
    step1:{nameLabel:'Who or what should the song be about?',namePlaceholder:'e.g. My friend Jorge, My colleagues, My boss, Real Madrid'},
    step2:{genres:['Surprise me','Pop','Rap','Rock','Soul','Country'],moods:[],showMood:false,showAge:false,showStyle:false,storyLabel:'What do they enjoy or do that\'s funny?',storyPlaceholder:'e.g. Loves board games, claps when laughing, obsessed with cats'},
    step3:{moreDetailsLabel:'Tell me more (optional)',moreDetailsPlaceholder:'e.g. Loves board games, claps when laughing, obsessed with cats'}
  },
  'Children Song':{
    step1:{nameLabel:'Child\'s name and age',namePlaceholder:'e.g. Emma, 2 years old'},
    step2:{genres:[],moods:[],showMood:false,showAge:false,showStyle:true,storyLabel:'What makes them smile',storyPlaceholder:'e.g. dinosaurs, cartoons, ice cream, Minecraft, swimming...'},
    step3:{moreDetailsLabel:'Tell me more about the child (optional)',moreDetailsPlaceholder:'favorite food, cartoon, word, joke, fairy tale, animal, or story - anything fun we should add to the song.'}
  },
  'Freestyle Song':{
    step1:{nameLabel:'What should the song be about?',namePlaceholder:'e.g. A birthday song for my friend, a rap about my dog stealing pizza, a romantic melody for my long-distance girlfriend...'},
    step2:{genres:['Surprise me','Pop','Rock','Pop-Rock','Hip-hop','Jazz','Electronic','Reggae','Folk'],moods:['Surprise me','Funny','Emotional','Epic','Cute'],showMood:true,showAge:false,showStyle:false,storyLabel:"What's the story or message you want in the song?",storyPlaceholder:'e.g. How we met in Paris...'},
    step3:{moreDetailsLabel:'Tell me more (optional)',moreDetailsPlaceholder:'You can write anything you\'d like to be included...'}
  }
};

var infoContent={
  love:'A romantic song perfect for expressing your feelings to your partner, soulmate, or loved one.',
  birthday:'A personalized birthday song celebrating someone special with their unique story and personality.',
  family:'A heartwarming song about family bonds, memories, and the people who matter most.',
  joke:'A funny, lighthearted song that pokes fun in a playful way - perfect for friends and colleagues.',
  children:'A fun, age-appropriate song designed to make kids smile with their favorite things.',
  freestyle:'Complete creative freedom - tell us your idea and we\'ll create a unique song just for you.'
};

var chips=document.querySelectorAll('#dedicationGrid .ss-chip');
var dedInput=document.getElementById('dedication_select');
var productTypeInput=document.getElementById('ssProductType');
var infoBox=document.getElementById('infoBox');

/* Chips */
chips.forEach(function(btn){
  btn.setAttribute('aria-pressed','false');
  btn.addEventListener('click',function(e){
    if(e.target.classList.contains('ss-info'))return;
    chips.forEach(function(b){b.classList.remove('active');b.setAttribute('aria-pressed','false')});
    this.classList.add('active'); this.setAttribute('aria-pressed','true');
    var value=this.getAttribute('data-value');
    dedInput.value=value; productTypeInput.value=value;
    updateFieldsForProduct(value);
    validateStep1(false);
  });
});

document.querySelectorAll('.ss-info').forEach(function(info){
  info.addEventListener('click',function(e){
    e.stopPropagation();
    var type=this.getAttribute('data-type');
    infoBox.textContent=infoContent[type];
    infoBox.hidden=false;
    setTimeout(function(){infoBox.hidden=true},5000);
  });
});

/* ===== UPDATE FIELDS (with translations & per-type placeholders) ===== */
function updateFieldsForProduct(productType){
  var config=productConfigs[productType]; if(!config) return;

  var trans=currentLang!=='en'?translations[currentLang]:null;

  // Base EN labels/placeholders
  var nameLabel             = config.step1.nameLabel;
  var namePlaceholder       = config.step1.namePlaceholder;
  var storyLabel            = config.step2.storyLabel;
  var storyPlaceholder      = config.step2.storyPlaceholder;
  var moreDetailsLabel      = config.step3.moreDetailsLabel;
  var moreDetailsPlaceholder= config.step3.moreDetailsPlaceholder;

  if(trans){
    // Per-type labels
    if(productType==='Love Song'        && trans.love_name)      nameLabel=trans.love_name;
    if(productType==='Happy Birthday'   && trans.birthday_name)  nameLabel=trans.birthday_name;
    if(productType==='Family Song'      && trans.family_name)    nameLabel=trans.family_name;
    if(productType==='Joke Song'        && trans.joke_name)      nameLabel=trans.joke_name;
    if(productType==='Children Song'    && trans.children_name)  nameLabel=trans.children_name;
    if(productType==='Freestyle Song'   && trans.freestyle_name) nameLabel=trans.freestyle_name;

    if(productType==='Happy Birthday'    && trans.birthday_story)   storyLabel=trans.birthday_story;
    else if(productType==='Family Song'  && trans.family_story)     storyLabel=trans.family_story;
    else if(productType==='Joke Song'    && trans.joke_story)       storyLabel=trans.joke_story;
    else if(productType==='Children Song'&& trans.children_story)   storyLabel=trans.children_story;
    else if(productType==='Freestyle Song'&& trans.freestyle_story) storyLabel=trans.freestyle_story;
    else if(trans.story_label) storyLabel=trans.story_label;

    if(productType==='Children Song' && trans.children_more) moreDetailsLabel=trans.children_more;
    else if(trans.other_more)        moreDetailsLabel=trans.other_more;

    // Per-type example placeholders for Step 1
    if(productType==='Love Song'        && trans.love_placeholder)
      namePlaceholder = trans.love_placeholder;
    else if(productType==='Happy Birthday' && trans.birthday_placeholder)
      namePlaceholder = trans.birthday_placeholder;
    else if(productType==='Family Song' && trans.family_placeholder)
      namePlaceholder = trans.family_placeholder;
    else if(productType==='Joke Song'   && trans.joke_placeholder)
      namePlaceholder = trans.joke_placeholder;
    else if(productType==='Children Song' && trans.children_placeholder)
      namePlaceholder = trans.children_placeholder;
    else if(productType==='Freestyle Song' && trans.freestyle_placeholder)
      namePlaceholder = trans.freestyle_placeholder;
    else if(trans.name_placeholder)
      namePlaceholder = trans.name_placeholder;

    // Optional generic placeholders
    if(trans.story_placeholder) storyPlaceholder = trans.story_placeholder;
    if(trans.more_placeholder)  moreDetailsPlaceholder = trans.more_placeholder;
  }

  document.getElementById('nameLabel').textContent=nameLabel;
  document.getElementById('recipient_name').placeholder=namePlaceholder;

  var genreSelect=document.getElementById('song_genre');
  var moodSelect=document.getElementById('song_mood');
  var genreField=document.getElementById('genreField');
  var moodField=document.getElementById('moodField');
  var styleField=document.getElementById('styleField');
  var ageField=document.getElementById('ageField');

  // Style vs Genre
  if(config.step2.showStyle){
    genreField.hidden=true; styleField.hidden=false;
    var styleLabel=document.getElementById('styleLabel');
    if(trans && trans.choose_style) styleLabel.textContent=trans.choose_style;
    var styleSel=document.getElementById('song_style');
    styleSel.innerHTML='<option value="" disabled selected>'+(trans&&trans.select_style?trans.select_style:'Select style')+'</option><option>Playful</option><option>Lullaby</option>';
    translateSelectOptions('song_style');
  }else{
    genreField.hidden=false; styleField.hidden=true;
    genreSelect.innerHTML='<option value="" disabled selected>'+(trans&&trans.select_genre?trans.select_genre:'Select genre')+'</option>';
    config.step2.genres.forEach(function(g){
      var opt=document.createElement('option'); opt.textContent=g; genreSelect.appendChild(opt);
    });
    translateSelectOptions('song_genre');
  }

  // Mood
  if(config.step2.showMood){
    moodField.hidden=false;
    moodSelect.innerHTML='<option value="" disabled selected>'+(trans&&trans.select_mood?trans.select_mood:'Select mood')+'</option>';
    config.step2.moods.forEach(function(m){
      var opt=document.createElement('option'); opt.textContent=m; moodSelect.appendChild(opt);
    });
    translateMoodOptions();
    if(trans && trans.choose_mood) document.getElementById('moodLabel').textContent=trans.choose_mood;
  }else{
    moodField.hidden=true;
  }

  // Age
  ageField.hidden=!config.step2.showAge;
  if(trans && trans.person_age) document.getElementById('ageLabel').textContent=trans.person_age;

  // Story + more
  document.getElementById('storyLabel').textContent=storyLabel;
  document.getElementById('song_story').placeholder=storyPlaceholder;

  document.getElementById('moreDetailsLabel').textContent=moreDetailsLabel;
  document.getElementById('more_details').placeholder=moreDetailsPlaceholder;
}

/* VOCAL TOGGLES */
var vocalBtns=document.querySelectorAll('.ss-toggle.ss-vocal');
var vocalHidden=document.getElementById('ssVocalValue');
var errVocal=document.getElementById('errVocal');
vocalBtns.forEach(function(btn){
  btn.addEventListener('click',function(){
    vocalBtns.forEach(function(b){b.setAttribute('aria-pressed','false')});
    this.setAttribute('aria-pressed','true');
    vocalHidden.value=this.getAttribute('data-value');
    errVocal.hidden=true;
    validateStep3(false);
  });
  btn.setAttribute('aria-pressed','false');
  btn.setAttribute('tabindex','0');
  btn.addEventListener('keydown',function(e){
    if(e.key==='Enter'||e.key===' '){e.preventDefault();this.click();}
  });
});

/* STEPS */
function showStep(n){
  steps.forEach(function(s){s.classList.remove('is-active')});
  steps[n-1].classList.add('is-active');
  stepBtns.forEach(function(b,i){
    b.classList.remove('is-active','is-done');
    b.disabled=i>n-1&&!(i<n-1);
    if(i<n-1){b.classList.add('is-done');b.disabled=false}
    if(i===n-1){b.classList.add('is-active');b.disabled=false;b.setAttribute('aria-current','step')}
    else{b.removeAttribute('aria-current')}
  });
  
  var trans=currentLang!=='en'?translations[currentLang]:null;
  if(trans && trans.song_price){
    var labels=document.querySelectorAll('.ss-song-price-label');
    labels.forEach(function(label){
      label.textContent=trans.song_price;
    });
  }
  
  if(n===3 && trans){
    var deliverySelect=document.getElementById('delivery_speed');
    if(deliverySelect){
      var options=deliverySelect.options;
      for(var i=1; i<options.length; i++){
        var opt=options[i];
        var variantId=opt.value;
        if(variantId==='46830917615846' && trans.express_delivery){
          opt.textContent=trans.express_delivery+' | €9.99';
        } else if(variantId==='46830917583078' && trans.fast_delivery){
          opt.textContent=trans.fast_delivery+' | €3.99';
        } else if(variantId==='46830917550310' && trans.standard_delivery){
          opt.textContent=trans.standard_delivery+' | €0.00';
        }
      }
    }
  }
}

/* VALIDATION */
function validateStep1(showErrors){
  var ok=true;
  var ded=dedInput.value.trim();
  var name=document.getElementById('recipient_name').value.trim();
  var nameInput=document.getElementById('recipient_name');
  var lang=document.getElementById('song_language').value;
  var langSelect=document.getElementById('song_language');
  
  if(!ded){
    ok=false;
    if(showErrors){
      document.getElementById('errDedication').hidden=false;
      document.querySelectorAll('#dedicationGrid .ss-chip').forEach(function(chip){
        chip.classList.add('has-error');
      });
    }
  } else {
    document.getElementById('errDedication').hidden=true;
    document.querySelectorAll('#dedicationGrid .ss-chip').forEach(function(chip){
      chip.classList.remove('has-error');
    });
  }
  
  if(!name){
    ok=false;
    if(showErrors){
      document.getElementById('errName').hidden=false;
      nameInput.classList.add('has-error');
    }
  } else {
    document.getElementById('errName').hidden=true;
    nameInput.classList.remove('has-error');
  }
  
  if(!lang){
    ok=false;
    if(showErrors){
      document.getElementById('errLanguage').hidden=false;
      langSelect.classList.add('has-error');
    }
  } else {
    document.getElementById('errLanguage').hidden=true;
    langSelect.classList.remove('has-error');
  }
  
  return ok;
}


function validateStep2(showErrors){
  var productType=productTypeInput.value;
  var config=productConfigs[productType]; if(!config) return false;
  var ok=true;
  var genre=document.getElementById('song_genre').value;
  var genreSelect=document.getElementById('song_genre');
  var mood=document.getElementById('song_mood').value;
  var moodSelect=document.getElementById('song_mood');
  var style=document.getElementById('song_style').value;
  var styleSelect=document.getElementById('song_style');
  var age=document.getElementById('person_age').value.trim();
  var ageInput=document.getElementById('person_age');
  var story=document.getElementById('song_story').value.trim();
  var storyArea=document.getElementById('song_story');

  if(config.step2.showStyle){
    if(!style){
      ok=false;
      if(showErrors){
        document.getElementById('errStyle').hidden=false;
        styleSelect.classList.add('has-error');
      }
    } else {
      document.getElementById('errStyle').hidden=true;
      styleSelect.classList.remove('has-error');
    }
  } else {
    if(!genre){
      ok=false;
      if(showErrors){
        document.getElementById('errGenre').hidden=false;
        genreSelect.classList.add('has-error');
      }
    } else {
      document.getElementById('errGenre').hidden=true;
      genreSelect.classList.remove('has-error');
    }
  }

  if(config.step2.showMood){
    if(!mood){
      ok=false;
      if(showErrors){
        document.getElementById('errMood').hidden=false;
        moodSelect.classList.add('has-error');
      }
    } else {
      document.getElementById('errMood').hidden=true;
      moodSelect.classList.remove('has-error');
    }
  }
  
  if(config.step2.showAge){
    if(!age){
      ok=false;
      if(showErrors){
        document.getElementById('errAge').hidden=false;
        ageInput.classList.add('has-error');
      }
    } else {
      document.getElementById('errAge').hidden=true;
      ageInput.classList.remove('has-error');
    }
  }
  
  if(!story){
    ok=false;
    if(showErrors){
      document.getElementById('errStory').hidden=false;
      storyArea.classList.add('has-error');
    }
  } else {
    document.getElementById('errStory').hidden=true;
    storyArea.classList.remove('has-error');
  }

  return ok;
}

function validateStep3(showErrors){
  var delivery=document.getElementById('delivery_speed').value;
  var deliverySelect=document.getElementById('delivery_speed');
  var vocal=vocalHidden.value;
  var ok=true;
  
  if(!delivery){
    ok=false;
    if(showErrors){
      document.getElementById('errDelivery').hidden=false;
      deliverySelect.classList.add('has-error');
    }
  } else {
    document.getElementById('errDelivery').hidden=true;
    deliverySelect.classList.remove('has-error');
  }
  
  if(!vocal){
    ok=false;
    if(showErrors){
      errVocal.hidden=false;
      document.querySelectorAll('.ss-vocal').forEach(function(btn){
        btn.classList.add('has-error');
      });
    }
  } else {
    errVocal.hidden=true;
    document.querySelectorAll('.ss-vocal').forEach(function(btn){
      btn.classList.remove('has-error');
    });
  }
  
  return ok;
}


/* Update price breakdown based on delivery speed */
function updatePriceBreakdown(){
  var deliverySelect=document.getElementById('delivery_speed');
  var selectedOption=deliverySelect.options[deliverySelect.selectedIndex];
  var deliveryPrice=selectedOption.getAttribute('data-price');
  
  var deliveryPriceEl=document.querySelector('.ss-delivery-price');
  var totalPriceEl=document.querySelector('.ss-total-price');
  
  if(!deliveryPriceEl || !totalPriceEl) return;
  
  var basePrice=14.99;  // New base price
  var deliveryFee=0;
  var totalPrice=basePrice;
  
  if(deliveryPrice){
    deliveryFee=parseFloat(deliveryPrice);
    totalPrice=basePrice+deliveryFee;
  }
  
  var trans=currentLang!=='en'?translations[currentLang]:null;
  var includedText=trans&&trans.included?trans.included:'Included';
  
  if(deliveryFee===0 || !deliveryPrice){
    deliveryPriceEl.textContent=includedText;
    deliveryPriceEl.classList.remove('has-fee');
  }else{
    deliveryPriceEl.textContent='+ €'+deliveryFee.toFixed(2).replace('.',',');
    deliveryPriceEl.classList.add('has-fee');
  }

  totalPriceEl.textContent='€'+totalPrice.toFixed(2).replace('.',',');
}

/* Live validate - hide errors on input */
['change','input'].forEach(function(ev){
  document.getElementById('dedication_select').addEventListener(ev,function(){
    document.getElementById('errDedication').hidden=true;
    document.querySelectorAll('#dedicationGrid .ss-chip').forEach(function(chip){
      chip.classList.remove('has-error');
    });
  });
  document.getElementById('recipient_name').addEventListener(ev,function(){
    document.getElementById('errName').hidden=true;
    this.classList.remove('has-error');
  });
  document.getElementById('song_language').addEventListener(ev,function(){
    document.getElementById('errLanguage').hidden=true;
    this.classList.remove('has-error');
  });

  document.getElementById('song_genre').addEventListener(ev,function(){validateStep2(false)});
  document.getElementById('song_mood').addEventListener(ev,function(){validateStep2(false)});
  document.getElementById('song_style').addEventListener(ev,function(){validateStep2(false)});
  document.getElementById('person_age').addEventListener(ev,function(){validateStep2(false)});
  document.getElementById('song_story').addEventListener(ev,function(){validateStep2(false)});
  document.getElementById('delivery_speed').addEventListener(ev,function(){
    document.getElementById('errDelivery').hidden=true;
    this.classList.remove('has-error');
    updatePriceBreakdown();
  });
});


/* Reset checkout button on bfcache */
function resetCheckoutButton(){
  var btn=document.getElementById('checkoutBtn');
  if(btn){btn.disabled=false;btn.textContent=(t('checkout',currentLang)||'Proceed to Checkout');}
}
window.addEventListener('pageshow',resetCheckoutButton);

/* Nav buttons */
document.getElementById('toStep2').addEventListener('click',function(){ if(validateStep1(true)) showStep(2) });
document.querySelector('[data-back="1"]').addEventListener('click',function(){ showStep(1) });
document.getElementById('toStep3').addEventListener('click',function(){ if(validateStep2(true)) showStep(3) });
document.querySelector('[data-back="2"]').addEventListener('click',function(){ showStep(2) });

form.addEventListener('submit',function(e){e.preventDefault()});

/* ===== Checkout handler ===== */
var checkoutBtn=document.getElementById('checkoutBtn');
checkoutBtn.addEventListener('click',function(){
  if(!validateStep3(true)) return;
  var btn=this; btn.disabled=true; var originalText=btn.textContent; btn.textContent='Processing…';


  var deliverySelect=document.getElementById('delivery_speed');
  var deliverySpeed=deliverySelect.value;

  var deliveryVariantMap={
  '46888746811622':46888746811622,  // Express (1 hour)
  '46888746778854':46888746778854,  // Fast (3-5 hours)
  '46888746746086':46888746746086   // Standard (10-12 hours)
};


  var selectedVariantId=deliveryVariantMap[deliverySpeed];
  if(!selectedVariantId){
    alert('Could not determine the correct variant for the selected delivery speed. Please refresh and try again.');
    btn.disabled=false; btn.textContent=originalText; return;
  }

  var productType=document.getElementById('ssProductType').value;
  var config=productConfigs[productType];

  var siteCode=(window.Shopify&&Shopify.locale)||(document.documentElement.lang||'').split('-')[0]||'en';
  siteCode=siteCode.toLowerCase();
  if(siteCode.startsWith('pt')) siteCode='pt';

  var siteLangMap={en:'en',es:'es',el:'el',it:'it',fr:'fr',pt:'pt-PT',de:'de'};
  var siteLangName=siteLangMap[siteCode]||'English';

  var properties={};
  properties['Song Language']=document.getElementById('song_language').value;
  if(config.step2.showStyle){
    var style=document.getElementById('song_style').value;
    if(style) properties['Song Style']=style;
  }else{
    var genre=document.getElementById('song_genre').value;
    if(genre) properties['Genre']=genre;
  }
  if(config.step2.showMood){
    var mood=document.getElementById('song_mood').value;
    if(mood) properties['Song Mood']=mood;
  }
  var nameLabel=config.step1.nameLabel;
  var recipientValue=document.getElementById('recipient_name').value;
  if(recipientValue){properties[nameLabel]=recipientValue;}
  if(config.step2.showAge){
    var age=document.getElementById('person_age').value;
    if(age) properties['How old is this person turning?']=age;
  }
  var storyLabel=config.step2.storyLabel;
  var storyValue=document.getElementById('song_story').value;
  if(storyValue){properties[storyLabel]=storyValue;}
  var moreDetails=document.getElementById('more_details').value;
  if(moreDetails){
    var moreLabel=config.step3.moreDetailsLabel;
    properties[moreLabel]=moreDetails;
  }

     // Add vocal gender preference (only if Male or Female, skip if No preference)
  var vocalValue = document.getElementById('ssVocalValue').value;
  if(vocalValue) {
    // Remove emojis and clean up the value
    var cleanVocal = vocalValue.replace(/👨‍🎤|👩‍🎤|🎵/g, '').trim();
    
    // Only add to properties if it's Male or Female (not "No preference")
    if(cleanVocal === 'Male' || cleanVocal === 'Female') {
      properties['Vocal gender'] = cleanVocal;
    }
    // If it's "No preference", we don't add it to properties at all
  }


  properties['Language Used']=siteLangName;

  fetch('/cart/clear.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'}})
  .then(function(){
    return fetch('/cart/add.js',{
      method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},
      body:JSON.stringify({id:selectedVariantId,quantity:1,properties:properties})
    });
  })
  .then(async function(res){
    var data=await res.json().catch(function(){return{}});
    if(!res.ok){
      var msg=(data&&data.description)||(data&&data.message)||'Something went wrong. Please try again.';
      throw new Error(msg);
    }
    return data;
  })
  .then(function(){window.location.href='/checkout'})
  .catch(function(err){
    console.error(err);
    alert(err.message||'Something went wrong. Please try again.');
    btn.disabled=false; btn.textContent=originalText;
  });
});

/* INIT */
showStep(1);
applyTranslations();
updatePriceBreakdown();

})();

